const settings = {
    tabs: {
      profile: 'Profile',
      security: 'Security',
      notifications: 'Notifications',
      preferences: 'Preferences',
      administration: 'Administration',
    },
    profileDescription: 'The account you are signed in with.',
    notificationsDescription: 'Choose how you want to be notified.',
    security: {
      device: 'Device',
      ipAddress: 'IP address',
      lastActive: 'Last active',
      status: 'Status',
      signOut: 'Sign out',
      signOutConfirm: {
        title: 'Sign out session',
        description:
          "This device's session will be ended and will need to sign in again. This action cannot be undone. Are you sure you want to sign it out?",
        confirm: 'Sign out',
      },
      removeDeviceConfirm: {
        title: 'Remove trusted device',
        description:
          '"{{deviceName}}" will no longer be trusted and will require multi-factor authentication at the next sign-in. This action cannot be undone. Are you sure you want to remove it?',
        confirm: 'Remove',
      },
      unknownDevice: 'Unknown device',
      mfaDescription: 'The extra verification required when you sign in.',
      sessionsDescription: 'These are devices currently signed in to your account.',
      trustedDevicesDescription: 'Devices that may skip extra verification.',
    },
    title: 'Settings',
    description: 'Customize application display and notification settings.',
    appearance: 'Appearance',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    language: 'Language Settings',
    selectLanguage: 'Display Language',
    languageOptions: {
      japanese: 'Japanese',
      english: 'English',
    },
    notifications: 'Notification Settings',
    enableNotifications: 'Enable in-app notifications',
    emailNotifications: 'Receive email notifications',
    notificationNote: 'Notification settings are saved in this browser.',
    activityTitle: 'Activity & Audit Logs',
    activityDescription: 'Review tenant activity history such as login, document, chat, CAD, and DRBFM operations (manager or above).',
    openActivityDashboard: 'Open Activity Dashboard',
    openAnomalyTriage: 'Review Anomaly Events',
    systemTitle: 'System Settings',
    systemDescription: 'Manage system settings and administration.',
    searchSettings: 'Search Settings',
    tenantSettingsFetchFailed: 'Failed to fetch tenant settings.',
    keywordMatching: 'Keyword matching processing',
    keywordMatchingTooltip: 'When ON, search queries are preprocessed with synonym expansion and keyword extraction. When OFF, only semantic search (AI meaning understanding) is used.',
    keywordMatchingEnabled: 'Keyword matching has been enabled.',
    keywordMatchingDisabled: 'Keyword matching has been disabled (semantic search only).',
    keywordMatchingEnabledDescription: 'Enabled: preprocesses queries with synonym expansion and keyword extraction',
    keywordMatchingDisabledDescription: 'Disabled: uses semantic search (RAG) only',
    updateFailed: 'Failed to update settings.',
    adminRequired: 'Administrator permission is required to change this setting.',
    featureSettings: 'Feature Settings',
    designVerification: 'Design verification',
    designVerificationTooltip: 'When ON, design verification is available from the sidebar, dashboard and DRBFM. When OFF it is unavailable in both the UI and the API.',
    designVerificationEnabled: 'Design verification has been enabled.',
    designVerificationDisabled: 'Design verification has been disabled.',
    designVerificationEnabledDescription: 'Enabled: the design verification item list is available',
    designVerificationDisabledDescription: 'Disabled: verification entry points and APIs are turned off',
    searchModesTitle: 'About search modes',
    keywordMatchOnLabel: 'Keyword match ON',
    keywordMatchOnDescription: 'Analyzes the entered query, expands synonyms, and extracts keywords before searching. Suitable for specific terms or product names.',
    keywordMatchOffLabel: 'Keyword match OFF',
    keywordMatchOffDescription: 'AI directly understands the meaning of the search query and performs semantic search. Suitable for natural-language questions.',
    dataManagement: 'Data Management',
    currentStatus: 'Current Status',
    registeredDocuments: '• Registered documents: {{count}}',
    defaultBackup: '• Default backup: {{status}}',
    available: 'Available',
    unavailable: 'Unavailable',
    dataResetTitle: 'About data reset',
    dataResetDescription: 'This restores document metadata to the saved default state. All currently uploaded document information returns to the backed-up state.',
    warningLabel: 'Warning',
    dataResetWarning: 'This operation cannot be undone. Current data will be overwritten by the backed-up state.',
    resetToDefault: 'Reset to default state',
    resetting: 'Resetting...',
    resetComplete: '✓ Reset complete: restored {{count}} documents',
    resetFailed: 'Reset failed',
    resetError: 'Error: {{message}}',
    resetConfirmTitle: 'Confirm Data Reset',
    resetConfirmQuestion: 'Are you sure you want to reset data to the default state?',
    resetConfirmDescription: 'This operation restores the current document metadata to the backed-up state.',
    irreversible: 'This operation cannot be undone.',
    executeReset: 'Run Reset',
  };

export default settings;
